export const EVAL_DAILY_LOG_SECTION_KEY = "daily-logs";

export const dailyLogSelectionId = (id) => `dl-${id}`;

export const isDailyLogSelectionId = (id) =>
  String(id || "").startsWith("dl-");

export const parseDailyLogSelectionId = (id) => {
  if (!isDailyLogSelectionId(id)) return null;
  const n = Number(String(id).slice(3));
  return Number.isInteger(n) && n > 0 ? n : null;
};

export const mapDailyLogToEvalForm = (log) => ({
  id: dailyLogSelectionId(log.id),
  dailyLogId: log.id,
  source: "daily-log",
  formName: log.formName || "Daily Log",
  filledByName: log.filledByName || log.employeeName || "",
  filledByRole: log.filledByRole || log.title || "",
  status: log.status,
  scheduleDate:
    log.scheduleDate ||
    log.serviceDate ||
    log.scheduledVisit?.visitDate ||
    null,
  marks: log.marks || [],
  attachmentCount: Number(log.attachmentCount) || 0,
  scheduledVisit: log.scheduledVisit || null,
});

export const formatPatientChartName = (patient) => {
  if (!patient) return "";
  if (patient.name && !patient.firstName && !patient.lastName) {
    return String(patient.name).trim();
  }
  const last = String(patient.lastName || "").trim();
  const first = [patient.firstName, patient.middleName]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ");
  if (last && first) return `${last}, ${first}`;
  return last || first || String(patient.name || "").trim();
};

export const dailyLogChartNavState = ({
  patientId,
  returnTo,
  patient,
}) => {
  const name = formatPatientChartName(patient);
  return {
    returnTo: returnTo || `/patients/${patientId}`,
    tab: "eval",
    evalSection: EVAL_DAILY_LOG_SECTION_KEY,
    lockedPatient: {
      id: Number(patientId),
      name,
      mrn: patient?.mrn || "",
      dateOfBirth: patient?.dateOfBirth || null,
      firstName: patient?.firstName || "",
      lastName: patient?.lastName || "",
      middleName: patient?.middleName || "",
    },
  };
};
